// extracted by mini-css-extract-plugin
export default {"error-container":"ErrorPage_error-container__NFWIY","error-content":"ErrorPage_error-content__xrKFN"};